








import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import rd from "../../modules/vRoutedefs";
import {requireNum} from "../../modules/utils";
import {componentLoad} from "../../modules/loading";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-qr-reader": componentLoad(() => import(/* webpackChunkName: "QrReader" */ "../qr/QrReader.vue"))
    }
})
export default class QrCardAdd extends CommonBase {

    get cancelTo() {
        return {name: rd.start.name};
    }

    onCardPending(ev) {
        const cardNum = requireNum(ev);
        ignoreRedundantNavErr(this.$router.push({name: rd.start.card.add.pending.name, params: {cardNum: ""+cardNum}}));
    }
}
